"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.px = exports.getVariationBorderColor = exports.getSpacingStyles = exports.getPropsStyles = exports.getColor = exports.getBorderRadiusStyle = exports.addOutline = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cssProps = require("./cssProps");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var getVariationBorderColor = function getVariationBorderColor(_ref) {
  var error = _ref.error,
    warning = _ref.warning;
  if (error) {
    return 'red70';
  }
  if (warning) {
    return 'yellow70';
  }
  return null;
};
exports.getVariationBorderColor = getVariationBorderColor;
var getColor = function getColor(selectors, fallbackColor, error, warning) {
  var variationBorderColor = getVariationBorderColor({
    error: error,
    warning: warning
  });
  return selectors.color(variationBorderColor || fallbackColor);
};
exports.getColor = getColor;
var getPropsStyles = function getPropsStyles(propsKeys, props) {
  var styles = {};
  propsKeys.forEach(function (propKey) {
    if (props[propKey]) {
      styles[propKey] = props[propKey];
    }
  });
  return styles;
};
exports.getPropsStyles = getPropsStyles;
var getSpacingStyles = function getSpacingStyles(propsKeys, props, spaceSelector) {
  var styles = {};
  propsKeys.forEach(function (propKey) {
    styles = _objectSpread(_objectSpread({}, styles), (0, _cssProps.cssValuesProp)(spaceSelector, props[propKey], propKey));
  });
  return styles;
};
exports.getSpacingStyles = getSpacingStyles;
var px = function px(value) {
  return typeof value === 'number' ? "".concat(value, "px") : value;
};
exports.px = px;
var getBorderRadiusStyle = function getBorderRadiusStyle(radiusSelector, borderRadius) {
  return (0, _cssProps.cssValuesProp)(radiusSelector, borderRadius, 'borderRadius');
};
exports.getBorderRadiusStyle = getBorderRadiusStyle;
var addOutline = function addOutline(width, offset, color, fillGap, radius, additionalStyle) {
  return {
    rest: _objectSpread({
      outlineColor: color,
      outlineWidth: 0,
      outlineOffset: offset
    }, additionalStyle),
    focus: _objectSpread(_objectSpread(_objectSpread({
      outlineColor: color,
      outlineWidth: width,
      outlineStyle: 'solid',
      outlineOffset: offset
    }, radius && {
      borderRadius: radius
    }), fillGap && {
      boxShadow: "0 0 0 ".concat(px(fillGap.width), " ").concat(fillGap.color)
    }), additionalStyle)
  };
};
exports.addOutline = addOutline;